export default class Country {
  id: number
  name: string
  tripmateCode: string

  constructor(props: any) {
    this.id = props.id
    this.name = props.name
  }

  static unitedStates() {
    return new Country({ id: 196, name: "United States" })
  }
}
